// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__19m12","col":"styles_col__1Jzyd","fulfillmentStatus":"styles_fulfillmentStatus__2ijrf","emailCol":"styles_emailCol__2Gber"};